import { Controller } from "@hotwired/stimulus"

// Opens the shared "Im Katalog speichern" modal from a button that is not part of a
// bulk bar: a single row's action, or the document-level "whole document" entry in the
// overflow menu (which passes no ids, so the server captures the entire tree).
export default class extends Controller {
  static values = { ids: Array, name: String }

  open() {
    document.dispatchEvent(
      new CustomEvent("catalog-save:open", {
        detail: { ids: this.idsValue, name: this.nameValue },
      }),
    )
  }
}
